import { object, string } from 'yup';

export const getValidation = () => {
  const validationSchema = object({
    email: string()
      .required('Email Address is a required field')
      .email('Invalid email')
      .default(''),
  });

  return { validationSchema, defaultValues: validationSchema.cast({}) };
};
